// IE 2026 10 09 / ODOO-345618 (заказ Игоря 09.10 через ie-webscm7: звено «ответственный» у сигналов — сигнал → причина → решение → стоимость → ответственный):
// чистая логика (без Vue / DOM — юнит tests/unit/cellResponsible.test.mjs) для
//   1) формы ячейки: ответственные у решения карточки проблемы (бэк cell_passport.story: problems[].responsible / responsible_text, story.responsible —
//      common_modules/signals_responsible.cell) и кнопка «Remind» → метод виджета cell_passport_remind (params: object / subject / country / month / signal /
//      cause / solution / responsible / text);
//   2) грида сигналов: кнопка «Mine» командной панели — чипс стола responsible_users ilike <id пользователя> (в память стола, как чипс «Object» блока OBJECTS:
//      pageGotoChip_apply, без Save); повторный клик снимает чипс (строка WHERE use: false). Колонку responsible_users даёт DS::Signals (бэк metric_data.RESP_SQL);
//      у источника без колонки чипс бэк не применяет — грид не меняется.
// Флаг fe.ux.signalsResponsible (дефолт ВКЛ); выкл — ни строки ответственного, ни кнопок.
import { cellObjects_wanted } from './cellObjects'
import { pageGotoChip_apply } from './pageGotoChip'

export const RESPONSIBLE_FLAG = 'fe.ux.signalsResponsible'
export const REMIND_METHOD = 'cell_passport_remind'
export const MINE_BINDING = 'responsible_users'
export const MINE_CONDITION = 'ilike'

const isObj = (x) => !!(x && typeof x === 'object' && !Array.isArray(x))
const str = (v) => (v === undefined || v === null) ? '' : String(v).trim()

// флаг включён (store.setting) — по умолчанию да
export function responsible_on(setting) {
    try { return typeof setting === 'function' ? setting(RESPONSIBLE_FLAG, true) !== false : true } catch (e) { return true }
}

// нужна ли кнопка «Mine» виджету: флаг и источник сигналов среди источников (как блок OBJECTS)
export function responsible_wanted({ source_segments, flagOn = true } = {}) {
    return cellObjects_wanted({ source_segments, flagOn })
}

// ответственные записи бэка (проблема / story / цепочка) → {users: [{user, email, name, role, via}], text} | null (поля нет — старый бэк / нет объекта)
export function responsible_of(x) {
    if (!isObj(x)) return null
    const src = Array.isArray(x.responsible) ? x.responsible : (isObj(x.responsible) && Array.isArray(x.responsible.users) ? x.responsible.users : null)
    const text = str(x.responsible_text || (isObj(x.responsible) ? x.responsible.text : ''))
    if (!src && !text && !('responsible' in x)) return null
    const users = (src || []).filter(isObj).map(u => ({ user: str(u.user), email: str(u.email), name: responsible_name(u), role: str(u.role), via: str(u.via), primary: u.primary === true, ...(u.no_user === true ? { no_user: true } : {}) }))   // IE 2026 10 10 / ODOO-345618: + primary, имя без «0»; IE 2026 10 11 / ODOO-345618 (заказ Игоря: согласование под ключ) — FE5: + no_user (держатель без записи USER)
        .filter(u => u.user || u.email)
    const k = users.findIndex(u => u.primary)   // IE 2026 10 10 / ODOO-345618: основной (бэк primary) — первым
    if (k > 0) users.unshift(users.splice(k, 1)[0])
    return { users, text: text || users.map(u => u.name).join(', ') }
}

// IE 2026 10 12 / ODOO-5800 (Игорь: «в цепочку проблема, причина, решение, ответственный нужно добавить "срок"… во всех отчётах»): срок проблемы — бэк problems[].due (YYYY-MM-DD | null),
// due_basis (ключ основания), due_basis_text (готовая подпись на языке пользователя — приоритетнее словаря), due_state ('overdue' — просрочено по CURRENT_DATE бэка).
// Флаг fe.ux.signalsDue (дефолт ВКЛ); выкл / нет due — ни «Due: …», ни строки карточки, ни поля напоминания
export const DUE_FLAG = 'fe.ux.signalsDue'
export const DUE_BASIS = {   // подписи оснований (английский источник; uk / ru — словари src/i18n/messages)
    demand_minus_lead: 'demand − lead time', approval_due_at: 'approval due date', window_start: 'version window start',
    registration_end: 'registration end', next_demand: 'nearest demand', cell_period: 'cell period',
}
export function due_on(setting) {
    try { return typeof setting === 'function' ? setting(DUE_FLAG, true) !== false : true } catch (e) { return true }
}
// сегодня по локальному календарю пользователя — 'YYYY-MM-DD'
export function due_today(now = new Date()) {
    const d = now instanceof Date ? now : new Date(now)
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0')
}
// запись бэка → {date, basis, basisText, overdue} | null (нет due / не дата). t — перевод подписи основания из словаря; today — 'YYYY-MM-DD' (тесты)
export function due_of(x, t = (s) => s, today = due_today()) {
    if (!isObj(x)) return null
    const date = str(x.due).slice(0, 10)
    if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return null
    const basis = str(x.due_basis)
    const basisText = str(x.due_basis_text) || (DUE_BASIS[basis] ? t(DUE_BASIS[basis]) : basis)
    return { date, basis, basisText, overdue: str(x.due_state).toLowerCase() === 'overdue' || date < str(today) }
}
// IE 2026 10 13 / ODOO-5800 (Р7 разбора сроков): просрочено в форме ячейки — только красный текст, без розовой плашки (как в таблице «Сигналы» без рамки).
// Флаг fe.ux.overdueTextOnly (дефолт ВКЛ; нет читателя / ошибка — ВКЛ); выкл — прежняя плашка «overdue»
export const OVERDUE_TEXT_ONLY_FLAG = 'fe.ux.overdueTextOnly'   // IE 2026 10 13 / ODOO-5800
export function overdueTextOnly_on(setting) {   // IE 2026 10 13 / ODOO-5800
    try { return typeof setting === 'function' ? setting(OVERDUE_TEXT_ONLY_FLAG, true) !== false : true } catch (e) { return true }
}
// строка карточки проблемы: [«Due», «2026-11-15 (demand − lead time) · overdue», 'overdue' | '']
export function due_row(d, t = (s) => s) {
    if (!d || !d.date) return null
    return [t('Due'), d.date + (d.basisText ? ' (' + d.basisText + ')' : '') + (d.overdue ? ' · ' + t('overdue') : ''), d.overdue ? 'overdue' : '']
}

// IE 2026 10 12 / ODOO-5800 (DESIGN resolved §0 / §5.4, WP-D): проблемы, которые политика решила сама (бэк story.resolved[] / story.resolved_n), и частично решённые (problems[].status 'partial' + resolved {policy, policy_title, auto_qty, residual_qty, note}).
// Флаг fe.ux.signalsResolved (дефолт ВКЛ, механизм как у fe.ux.signalsDue); выкл — ни блока RESOLVED, ни бейджа partial
export const RESOLVED_FLAG = 'fe.ux.signalsResolved'   // IE 2026 10 12 / ODOO-5800
export function resolved_on(setting) {   // IE 2026 10 12 / ODOO-5800: чтение флага по store.setting (нет читателя / ошибка — ВКЛ)
    try { return typeof setting === 'function' ? setting(RESOLVED_FLAG, true) !== false : true } catch (e) { return true }   // IE 2026 10 12 / ODOO-5800
}   // IE 2026 10 12 / ODOO-5800

// IE 2026 10 10 / ODOO-345618 (Игорь 10.10: «я ожидаю что "Ответственный" — это будет ссылка, и не совсем пойму почему сейчас несколько ответственных»):
// ОДИН ответственный ссылкой на запись пользователя (USER) + «+N» (остальные — по раскрытию / в подсказке). Флаг fe.ux.signalsResponsibleLink (дефолт ВКЛ);
// выкл — прежний текст бэка без ссылок.
export const RESPONSIBLE_LINK_FLAG = 'fe.ux.signalsResponsibleLink'
export const USER_SEGMENT = 'USER'
const EMPTY_NAMES = ['', '0', 'none', 'null', 'false']
export function responsible_name(u) {
    if (!isObj(u)) return ''
    for (const k of ['name', 'email', 'user']) { const v = str(u[k]); if (!EMPTY_NAMES.includes(v.toLowerCase())) return v }
    return ''
}
export function responsible_linkOn(setting) {
    try { return typeof setting === 'function' ? setting(RESPONSIBLE_LINK_FLAG, true) !== false : true } catch (e) { return true }
}
// подсказка: все люди с ролями («Бойко · ApprovedPM · b@x.ua»), основной помечен
export function responsible_tip(users, t = (s) => s) {
    return (Array.isArray(users) ? users : []).filter(isObj).map((u, i) => [responsible_name(u), str(u.role).replace(/^access-/, ''), str(u.email) !== responsible_name(u) ? str(u.email) : '']
        .filter(Boolean).join(' · ') + (i === 0 && u.primary ? ' (' + t('responsible') + ')' : '')).join('\n')
}
// {primary, others, more, tip}: основной (primary бэка, иначе первый), остальные, их число; нет людей — null
export function responsible_people(r, t) {
    const users = (r && Array.isArray(r.users) ? r.users : Array.isArray(r) ? r : []).filter(isObj).filter(u => str(u.user) || str(u.email))
    if (!users.length) return null
    const k = Math.max(0, users.findIndex(u => u.primary === true))
    const primary = users[k], others = users.filter((u, i) => i !== k)
    return { primary, others, more: others.length, tip: responsible_tip([primary, ...others], t) }
}
// ссылка на запись пользователя (id USER; без id — по e-mail, у USER DM id = e-mail у части людей)
export function responsible_ref(u) {
    if (u && u.no_user === true) return null   // IE 2026 10 11 / ODOO-345618 (заказ Игоря: согласование под ключ) — FE5: записи USER нет — ссылки нет (имя текстом, e-mail в подсказке)
    const id = str(u && (u.user || u.email))
    return id ? { segment: USER_SEGMENT, id } : null
}
// люди строки грида: поле responsible (массив или JSON-текст DS::Signals / грида сигналов отчёта); нет / не разобрать — []
export function responsible_cellUsers(dataItem) {
    if (!isObj(dataItem)) return []
    const d = isObj(dataItem.doc) && !('responsible' in dataItem) ? dataItem.doc : dataItem
    let v = d.responsible
    if (typeof v === 'string') { try { v = v.trim() ? JSON.parse(v) : [] } catch (e) { v = [] } }
    if (!Array.isArray(v)) return []
    const r = responsible_of({ responsible: v })
    return r ? r.users : []
}
// HTML ячейки «Responsible»: имя основного ссылкой (data-resp-user) + « +N» (все — в подсказке); esc — экранирование
export function responsible_cellHtml(users, esc, t) {
    const p = responsible_people(users, t)
    if (!p) return ''
    const ref = responsible_ref(p.primary)
    return (p.primary && p.primary.no_user === true ? `<span class="resp-user-name" title="${esc(p.tip)}">${esc(responsible_name(p.primary))}</span>`
        : `<a class="resp-user-link" data-resp-user="${esc(ref ? ref.id : '')}" title="${esc(p.tip)}">${esc(responsible_name(p.primary))}</a>`) +
        (p.more ? `<span class="resp-user-more" title="${esc(p.tip)}"> +${p.more}</span>` : '')
}

// текущий пользователь среди ответственных (по id либо e-mail без учёта регистра)
export function responsible_isMine(users, user) {
    const id = str(user && user.id), em = str(user && user.email).toLowerCase()
    return (Array.isArray(users) ? users : []).some(u => isObj(u) && ((id && str(u.user) === id) || (em && str(u.email).toLowerCase() === em)))
}

// параметры метода cell_passport_remind по контексту story формы (where ячейки, month) и карточке проблемы (ids модели сигналов v2, ответственные бэка)
export function remind_params(ctx, entry, text = '') {
    const where = Array.isArray(ctx && ctx.where) ? ctx.where : []
    const dim = (k) => { const w = where.find(p => Array.isArray(p) && p[0] === k); return w ? str(w[1]) : '' }
    const e = isObj(entry) ? entry : {}
    const r = responsible_of(e)
    const out = { object: dim('object'), subject: dim('subject') || dim('calc_subject'), country: dim('country'), month: str(ctx && ctx.month).slice(0, 7),
        signal: str(e.signal_id || (isObj(e.signal) && e.signal.code) || e.code), cause: str(e.cause_id), solution: str(e.solution_id), text: str(text).slice(0, 1000) }
    if (r && r.users.length) out.responsible = r.users
    const d = due_of(e)   // IE 2026 10 12 / ODOO-5800: срок проблемы — в журнал / тему / тело письма напоминания (бэк signals_responsible.remind; нет due — поля нет)
    if (d) { out.due = d.date; if (d.basis) out.due_basis = d.basis; if (d.basisText) out.due_basis_text = d.basisText; if (d.overdue) out.due_state = 'overdue' }
    return out
}

// ответ метода → {ok, text} для уведомления (строки UI — английские, перевод словарём вызывающего)
export function remind_result(answer, t = (s, p) => String(s || '').replace(/\{(\w+)\}/g, (m, k) => (p && k in p) ? String(p[k]) : m)) {
    const r = isObj(answer) ? answer : {}
    if (r.state === 'ok') return { ok: true, text: t('Reminder sent to {names}', { names: str(r.text) || String((r.recipients || []).length) }) + (r.email ? ' · ' + t('{n} e-mail', { n: r.email }) : '') }
    if (r.state === 'no responsible') return { ok: false, text: t('No responsible user for this cell — nobody to remind') }
    if (r.state === 'off') return { ok: false, text: t('Reminders are switched off (not-signals_responsible)') }
    return { ok: false, text: t('The reminder is not sent') + (r.state ? ': ' + String(r.state).slice(0, 120) : '') }
}

// ---------- «Mine» грида ----------
// конфиг чипса (тот же путь, что у блока OBJECTS: pageGotoChip_run на ТЕКУЩЕЙ странице стола)
export function mine_cfg(WIDGET) {
    const page = str(WIDGET && WIDGET.page)
    if (!page) return null
    return { page, chip_binding: MINE_BINDING, row_binding: MINE_BINDING, trigger: 'cell', workspace: '', column: '', condition: MINE_CONDITION }
}

// значение чипса — id пользователя (колонка responsible_users: «id;e-mail;…», условие ilike → '%id%'); подпись — имя
export function mine_value(user) {
    const id = str(user && user.id) || str(user && user.email)
    if (!id) return null
    return { value: id, valueStr: str(user && user.title) || str(user && user.email) || id }
}

// строка WHERE стола чипса «Mine» включена с этим пользователем
export function mine_isOn(WHERE, user) {
    const v = mine_value(user)
    if (!v) return false
    return (Array.isArray(WHERE) ? WHERE : []).some(r => isObj(r) && r.use !== false && str(isObj(r.leftValue) ? r.leftValue.value : r.leftValue) === MINE_BINDING
        && (Array.isArray(r.attrs) ? r.attrs : []).some(a => isObj(a) && a.use !== false && isObj(a.rightValue) && str(a.rightValue.value) === v.value))
}

// переключение: нет чипса — поставить (pageGotoChip_apply), есть — снять (use: false, attrs: []). Исходный массив не меняется. → {WHERE, on}
export function mine_toggle(WHERE, cfg, user) {
    const v = mine_value(user)
    const rows = (Array.isArray(WHERE) ? WHERE : []).map(r => isObj(r) ? { ...r } : r)
    if (!v || !cfg) return { WHERE: rows, on: false, changed: false }
    if (mine_isOn(rows, user)) {
        for (const r of rows) {
            if (isObj(r) && str(isObj(r.leftValue) ? r.leftValue.value : r.leftValue) === MINE_BINDING) { r.use = false; r.attrs = [] }
        }
        return { WHERE: rows, on: false, changed: true }
    }
    const res = pageGotoChip_apply(rows, cfg, v)
    return { WHERE: res.WHERE, on: true, changed: true }
}

// кнопка командной панели грида (AttrButton → executeVueObjMethod signalsMine_Click)
export function mine_button({ t = (s) => s, on = false, source_name = '', binding = '' } = {}) {
    return { name: 'button-signals_mine', autoGeneratedButton: true, attr_type: 'AttrButton', source_name, binding, showCommandTitle: true, title: t('Mine'),
        tooltip: on ? t('My signals: the Mine chip is on — click to show all rows') : t('My signals: only the rows where I am responsible (chip responsible_users)'),
        command: 'executeVueObjMethod', method: 'signalsMine_Click', cssClass: 'pi pi-user p-button-white' + (on ? ' p-button-warning' : '') }
}

// IE 2026 10 12 / ODOO-5800 (Игорь 12.10: «в виджете "Сигнали" вместо кнопки "Мої" добавь чипс "Мої", который можно добавить из формы списка чипсов»): чипс грида
// CHIP-Where с meta.key 'mine' (responsible_users ilike «= current_user» — макрос текущего пользователя, бэк attrs.chip_user_macro_rows; пакет конфигурации
// handoff-tools/2026-10-12/my_chip) стоит в списке чипсов выключенным, пользователь включает его из формы списка. Виджету с таким чипсом кнопка «Mine»
// командной панели не нужна — прячем. Флаг fe.ux.signalsMineChip (дефолт ВКЛ); выкл — кнопка как раньше.
export const MINE_CHIP_FLAG = 'fe.ux.signalsMineChip'   // IE 2026 10 12 / ODOO-5800
export const MINE_CHIP_KEY = 'mine'   // IE 2026 10 12 / ODOO-5800
export function mineChip_on(setting) {   // IE 2026 10 12 / ODOO-5800: чтение флага (нет читателя / ошибка — ВКЛ)
    try { return typeof setting === 'function' ? setting(MINE_CHIP_FLAG, true) !== false : true } catch (e) { return true }
}
// есть ли у записи виджета чипс «Mine» (doc.viewParams.<грид>.CHIPS[].meta.key === 'mine', любой грид, включён или нет)
export function mineChip_has(doc) {   // IE 2026 10 12 / ODOO-5800
    const vp = isObj(doc) && isObj(doc.viewParams) ? doc.viewParams : null
    if (!vp) return false
    return Object.values(vp).some(g => isObj(g) && Array.isArray(g.CHIPS) && g.CHIPS.some(c => isObj(c) && isObj(c.meta) && str(c.meta.key) === MINE_CHIP_KEY))
}
// прятать ли кнопку «Mine»: флаг ВКЛ и у виджета есть чипс «Mine»
export function mineChip_hidesButton(doc, setting) {   // IE 2026 10 12 / ODOO-5800
    return mineChip_on(setting) && mineChip_has(doc)
}
